/* ******************************************************* Expense */
export interface Expense {
    id: number;
    expense_name: string;
}

export const mapExpense = (data: any): Expense => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: Expense = {
        id: data.id,
        expense_name: data.expense_name,
    }

    return response;
}

export const mapExpenses = (data: any[]): Expense[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapExpense);
}
/* ******************************************************* */